import { useEffect } from "react";
import { appStore } from "src/framework/store/AppStore";
import { EdicaoAvancada } from "src/components/projetos/EdicaoAvancada";
import { useParams } from "react-router-dom";
import defaultListStore from "src/framework/store/DefaultListStore";

const PAGE_TITLE = "Edição avançada";

interface ParamsEdicaoAvancada {
    codigo_projeto: string;
}

const ProjetosEdicaoAvancadaPage = () => {
    const { codigo_projeto } = useParams<ParamsEdicaoAvancada>();

    useEffect(() => {
        (async () => {
            await defaultListStore.getComponentes()
        })();

        appStore.setPageTitle(PAGE_TITLE);

        return () => {
            appStore.setPageTitle("");
        }
    }, [])

    return (
        <div className="container">
            <div className="row">
                <div className="X12">
                    {codigo_projeto !== null && <EdicaoAvancada codigoProjeto={codigo_projeto} />}
                    {!codigo_projeto && "Codigo do projeto não informado"}
                </div>
            </div>
        </div>
    );
};

export { ProjetosEdicaoAvancadaPage };
